import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'vsc-bad-request',
    templateUrl: './bad-request.component.html',
    styleUrls: ['./bad-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BadRequestComponent {
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {}

    navigateToHome(): void {
        this.router.navigate(['../home'], { relativeTo: this.activatedRoute });
    }
}
